import { useScheduleData } from "../hooks/useScheduleData"
import GameCard from "./GameCard"
import {
    SimpleGrid,
    Text
} from "@chakra-ui/react"

const Schedule = ({ isoDate, onGameClick, currentGamePk }) => {
    const { data } = useScheduleData(isoDate)

    if (data?.length === 0) {
        return <Text align='center' color="hero.subtext" fontWeight="900" py={10}>NO GAMES ON SCHEDULE</Text>;
    }

    // Wrapping grid: the full slate (up to 15 games) stays visible at once —
    // 3-up on phones, wider screens get more columns
    return (
        <SimpleGrid
            columns={{ base: 3, md: 5, lg: 6 }}
            spacing={1.5}
            px={4}
        >
            {data?.map(gamePk => (
                <GameCard
                    key={gamePk}
                    gamePk={gamePk}
                    selected={String(gamePk) === String(currentGamePk)}
                    onClick={() => onGameClick(gamePk)}
                />
            ))}
        </SimpleGrid>
    );
}

export default Schedule
